<template>
    <b-sidebar
        id="service-form-sidebar"
        :visible="isServiceFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(serviceData)"
        @hidden="resetForm"
        @change="(val) => $emit('update:is-service-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1" >
                <h5 class="mb-0">Service Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>

            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
                <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm" >
                    <b-tabs v-model="tabIndex">
                        <b-tab title="Content">
                            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                                <b-tab v-for="(lang, key) in langs" :key="'tab-' + key" :title="lang.name" >
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'title_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group label="Title" :label-for="'title_' + lang.code" >
                                            <b-form-input
                                                :id="'title_' + lang.code"
                                                v-model="Data.title[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'Title (' + lang.code + ')'"
                                                @input="changeTitle(lang.code)"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>

                                    <validation-provider
                                        #default="validationContext"
                                        :name="'description_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                        label="Description"
                                        :label-for="'description_' + lang.code"
                                        >
                                        <quill-editor
                                            :options="editorOptions"
                                            :id="'description_' + lang.code"
                                            v-model="Data.description[lang.code]"
                                        />

                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>

                                    <validation-provider
                                        #default="validationContext"
                                        :name="'slug' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Slug"
                                            :label-for="'slug' + lang.code"
                                        >
                                        <b-form-input
                                            :id="'slug' + lang.code"
                                            v-model="Data.slug[lang.code]"
                                            autofocus
                                            :state="getValidationState(validationContext)"
                                            trim
                                            :placeholder="'Slug (' + lang.code + ')'"
                                        />
                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-tab>
                            </b-tabs>
                            <hr />

                            <validation-provider
                                #default="validationContext"
                                name="category_id"
                                rules="min:0"
                            >
                                <b-form-group label="Category" label-for="category_id">
                                    <v-select
                                        id="category_id"
                                        v-model="Data.category_id"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="title"
                                        :reduce="(option) => option.id"
                                        :options="
                                            catsData.map((g) => ({
                                                title: g.title[currentLocale],
                                                id: g.id,
                                            }))
                                        "
                                    />

                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <div class="border rounded p-2">
                                <h4 class="mb-1">Cover Image</h4>
                                <b-media no-body vertical-align="center" class="flex-column flex-md-row">
                                    <b-media-aside>
                                    <b-img
                                        :src="featuredImage || require('@/assets/images/no-image.png')"
                                        height="110"
                                        width="170"
                                        class="rounded mr-2 mb-1 mb-md-0"
                                    />
                                    </b-media-aside>
                                    <b-media-body>
                                    <small class="text-muted">
                                        Required image resolution 800x400, image size 10mb.
                                    </small>
                                    <b-card-text class="my-50"></b-card-text>
                                    <div class="d-inline-block">
                                        <b-form-file
                                            ref="refInputEl"
                                            v-model="imgFile"
                                            accept=".jpg, .png, .gif, .webp"
                                            placeholder="Choose file"
                                            @input="inputImageRenderer"
                                        />
                                    </div>
                                    <b-card-text class="my-50">
                                        <b-button
                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                        variant="outline-primary"
                                        v-if="featuredImage"
                                        @click="removeImage"
                                        >
                                        Remove Image
                                        </b-button>
                                    </b-card-text>
                                    </b-media-body>
                                </b-media>
                            </div>
                            <br />

                            <validation-provider
                                #default="validationContext"
                                name="IsActive"
                                rules="min:0"
                            >
                                <b-form-group label="Is Active" label-for="IsActive">
                                    <b-form-checkbox
                                        id="isactive"
                                        checked="true"
                                        class="custom-control-success"
                                        v-model="Data.is_active"
                                        switch
                                    />

                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <repeater-section-form
                                v-if="isServiceFormSidebarActive && serviceData.id"
                                @refesh-list="refeshList"
                                :service-data="serviceData"
                                :service-input-content-remove.sync="ServiceInputContentRemove"
                                :service-input-content.sync="ServiceInputContent"
                            />
                        </b-tab>

                        <b-tab title="SEO">
                        <validation-provider
                            #default="validationContext"
                            name="meta_title"
                            rules="min:0"
                        >
                            <b-form-group label="Meta Title" label-for="meta_title">
                            <b-form-input
                                id="meta_title"
                                v-model="Data.meta_title"
                                autofocus
                                :state="getValidationState(validationContext)"
                                trim
                                placeholder="Meta Title"
                            />
                            <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="validationContext"
                            name="meta_description"
                            rules="min:0"
                            
                        >
                            <b-form-group
                            label="Meta Description"
                            label-for="meta_description"
                            >
                            <b-form-input
                                id="meta_description"
                                v-model="Data.meta_description"
                                autofocus
                                :state="getValidationState(validationContext)"
                                trim
                                placeholder="Meta Description"
                            />

                            <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="validationContext"
                            name="meta_keywords"
                            rules="min:0"
                        >
                            <b-form-group label="Meta Keywords" label-for="meta_keywords">
                            <b-form-input
                                id="meta_keywords"
                                v-model="Data.meta_keywords"
                                autofocus
                                :state="getValidationState(validationContext)"
                                trim
                                placeholder="Meta Keywords"
                            />

                            <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        </b-tab>
                    </b-tabs>

                    <div class="d-flex mt-2">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="outline-success"
                            class="mr-2"
                            type="submit"
                        >
                            Save
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            type="button"
                            variant="outline-danger"
                            @click="hide"
                        >
                            Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import { BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,
    BTabs, BTab,
} from "bootstrap-vue";
import { BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile, } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, onUnmounted } from "@vue/composition-api";
import { required, alphaNum, email, password, confirmed } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { slugify } from "@/@fake-db/utils";
import Quill from 'quill'

const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
import { quillEditor } from "vue-quill-editor";
import languagesStoreModule from "@/views/languages/languagesStoreModule";
import RepeaterSectionForm from '../products-form/RepeaterSectonForm.vue';
import productSectionStoreModule from '../productSectionStoreModule';
import productBlockStoreModule from '../productBlockStoreModule';

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,
        BTabs, BTab, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile, vSelect,
        quillEditor, ValidationProvider, ValidationObserver, RepeaterSectionForm,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: "isServiceFormSidebarActive",
        event: "update:is-service-form-sidebar-active",
    },
    props: {
        isServiceFormSidebarActive: {
            type: Boolean,
            required: true,
        },
        serviceData: {
            type: Object,
            required: false,
        },
        contentsData: {
            type: Array,
            required: false,
        },
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
        editorOptions (){
            return $themeConfig.snowOption
        }
    },
    setup(props, { emit }) {
        const {  appRef } = $themeConfig.app
        const toast = useToast();
        const catsData = ref([]);
        const tabIndex = ref(0);
        const langs = ref([]);

        const LANGUAGES_STORE_MODULE_NAME = "app-languages";
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME))
        store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);

        onUnmounted(() => {
        if (store.hasModule(LANGUAGES_STORE_MODULE_NAME))
            store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
        });

        const SECTION_STORE_MODULE_NAME = 'product-section';
        if (!store.hasModule(SECTION_STORE_MODULE_NAME)) store.registerModule(SECTION_STORE_MODULE_NAME, productSectionStoreModule)
        onUnmounted(() => {
            if (store.hasModule(SECTION_STORE_MODULE_NAME)) store.unregisterModule(SECTION_STORE_MODULE_NAME)
        });

        const BLOCK_STORE_MODULE_NAME = 'section-block';
        if (!store.hasModule(BLOCK_STORE_MODULE_NAME)) store.registerModule(BLOCK_STORE_MODULE_NAME, productBlockStoreModule)
        onUnmounted(() => {
            if (store.hasModule(BLOCK_STORE_MODULE_NAME)) store.unregisterModule(BLOCK_STORE_MODULE_NAME)
        });

        const getLocalSite = JSON.parse(localStorage.getItem('site'))


        const fetchCategiryData = () => {
            try {
            store.dispatch('app-product/fetchCats', {})
                .then(response => {
                    catsData.value = response.data.data
                })
            } catch(error) {
                console.log(`error fetch category: ${error}`)
            }
        }

        fetchCategiryData()

        const userStorage = JSON.parse(localStorage.getItem("userData"));
        const blankData = {
            id: null,
            title: {},
            description: {},
            slug: {},
            category_id: null,
            is_active: true,
            sites_id: getLocalSite.id,
            created_by: userStorage.id,
            updated_by: userStorage.id,
            // featuredImage: null,
            // imgFile: null,
            meta_title: '',
            meta_description: '',
            meta_keywords: '',
        };
        const Data = ref(blankData);
        const repeaters = {
            id: null,
            title: {},
            slug: {},
            description: {},
            ordering_count: 0,
        };
        const ServiceInputContentRemove = ref([]);
        const ServiceInputContent = ref([JSON.parse(JSON.stringify(repeaters))]);
        const featuredImage = ref(null)
        const imgFile = ref(null)

        const resetData = () => {
            Data.value = JSON.parse(JSON.stringify(blankData));
            imgFile.value = null
        };

        const getData = async (data) => {
            tabIndex.value = 0;
            ServiceInputContent.value = [];

            if (data) {
                Data.value.id = data.id
                Data.value.title = data.title
                Data.value.description = data.description
                Data.value.slug = data.slug
                Data.value.category_id = Number(data.categories)
                Data.value.is_active = data.is_active? true: false
                Data.value.sites_id = data.sites_id
                Data.value.created_by = data.created_by
                Data.value.updated_by = data.updated_by
                featuredImage.value = data.cover_image
                Data.value.meta_title = data.meta_title
                Data.value.meta_description = data.meta_description
                Data.value.meta_keywords = data.meta_keywords

                if(data.contents && data.contents.length){
                    ServiceInputContent.value = data.contents
                } else {
                    ServiceInputContent.value = []
                }
            }
        };

        const getLangs = (fil) => {
            store.dispatch("app-languages/fetchData", fil).then((res) => {
                if (res.data.success) {
                langs.value = res.data.data;
                }
            });
        };

        let filter = {
            is_active:1,
        }

        getLangs(filter);

        const onSubmit = () => {
            let formData = new FormData()

            // Convert boolean to int
            const userStorage = JSON.parse(localStorage.getItem("userData"));
            Data.value.is_active = Data.value.is_active ? 1 : 0
            Data.value.updated_by = userStorage.id

            // Handle repeater content
            // if (ServiceInputContentRemove.value.length > 0) {
            //     Data.value.content_remove = JSON.stringify(ServiceInputContentRemove.value)
            // }
            // if (ServiceInputContent.value.length > 0) {
            //     // inject translated title into each repeater
            //     for (const [key, value] of Object.entries(ServiceInputContent.value)) {
            //         ServiceInputContent.value[key].title_lang = JSON.stringify(value.title)
            //     }
            //     Data.value.content = JSON.stringify(ServiceInputContent.value)
            // }

            // Append normal fields
            // for (const [key, value] of Object.entries(Data.value)) {
            //     if (key === "title" || key === "description" || key === "slug" || key === "sub_title" || key === "header_description") {
            //         formData.append(key, JSON.stringify(value))
            //     }
            // }

            formData.append('data', JSON.stringify(Data.value))

            if (imgFile.value) {
                formData.append("imgFile", imgFile.value)
            }

            // Extra counts
            // formData.append("count_conent_remove", ServiceInputContentRemove.value.length)
            // formData.append("count_conent", ServiceInputContent.value.length)

            // Update or create
            if (Data.value.id) {
                store.dispatch("app-product/updateProduct", { formData }).then(handleResponse)
            } else {
                store.dispatch("app-product/addProduct", { formData }).then(handleResponse)
            }
        }

        function handleResponse(res) {
            if (res.data.success) {
                toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                    title: `Success`,
                    icon: "BellIcon",
                    variant: "success",
                    text: `${res.data.message}`,
                },
                })

                emit("refetch-data")
                emit("update:is-service-form-sidebar-active", false)
            } else {
                toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                    title: `Error`,
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                },
                })
            }
        }


        const changeTitle = (lang) => {
        if(lang){
            Data.value.slug[lang] = slugify(Data.value.title[lang]);
        }
        };
        const refeshList = async () => {
            emit("refetch-data");
        };
        const {
        refFormObserver,

        getValidationState,
        resetForm,
        } = formValidation(resetData);

        const refInputEl = ref(null);
        const refIconInputEl = ref(null);

        function readFileAsBase64(file, callback) {
            if (!file) return
            const reader = new FileReader()
            reader.onload = e => callback(e.target.result)
            reader.readAsDataURL(file)
        }

        const inputImageRenderer = () => {
            const file = imgFile.value
            if (!file) return

            readFileAsBase64(file, (base64) => {
                featuredImage.value = base64
            })
        }

        const removeImage = () => {
            featuredImage.value = null
            imgFile.value = null
            if (refInputEl.value) refInputEl.value.reset()
        }

        return {
            Data,
            onSubmit,
            catsData,
            refFormObserver,
            getValidationState,
            resetForm,
            getData,
            tabIndex,
            refInputEl,
            inputImageRenderer,
            removeImage,
            changeTitle,
            ServiceInputContent,
            ServiceInputContentRemove,
            langs,
            refeshList,
            ServiceInputContent,
            ServiceInputContentRemove,
            refIconInputEl,
            featuredImage,
            imgFile,
        };
    },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
</style>